'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var utils = require('./utils.js');

var InfiniteScrollCheckStateManager = function (props) {
    var _a = props.defaultAllChecked, defaultAllChecked = _a === void 0 ? false : _a, _b = props.defaultCheckedValues, defaultCheckedValues = _b === void 0 ? [] : _b, reporter = props.reporter;
    var defaultChecked = utils.getDefaultCheckState(defaultCheckedValues);
    var _c = React.useState(defaultAllChecked), allChecked = _c[0], setAllChecked = _c[1];
    var _d = React.useState(defaultAllChecked), allSelected = _d[0], setAllSelected = _d[1];
    var _e = React.useState(defaultChecked), allValues = _e[0], setAllValues = _e[1];
    React.useEffect(function () {
        reporter(allChecked, allSelected, tslib.__assign({}, allValues));
    }, [allChecked, allSelected, allValues]);
    return {
        setAllChecked: function (checked) {
            setAllChecked(checked);
            setAllSelected(checked);
            var newState = tslib.__assign({}, allValues);
            Object.keys(newState).forEach(function (key) {
                newState[key] = checked;
            });
            setAllValues(newState);
        },
        selectValue: function (value, selected) {
            var newState = tslib.__assign({}, allValues);
            newState[value] = selected;
            setAllValues(newState);
            if (!selected) {
                setAllChecked(false);
            }
        },
        addMoreValues: function (values) {
            var newState = tslib.__assign({}, allValues);
            values.forEach(function (v) {
                if (newState[v] === true) {
                    return;
                }
                newState[v] = allSelected;
            });
            setAllValues(newState);
        },
    };
};

module.exports = InfiniteScrollCheckStateManager;
